// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "f43d90f3" + "-" + "c979df9e63f11eaf" + ".js";
};